import React, { ReactNode } from 'react';
import { Button, notification, message } from 'antd';

const currentNotification = '';
let currentNotificationModal;

interface NotifProps {
  message?: string;
  description?: string | ReactNode;
  type?: 'success' | 'info' | 'warning' | 'error';
  button?: any;
  buttons?: ReactNode;
  duration?: number;
  onClose?: () => any;
  style?: React.CSSProperties;
}
export const openNotification = ({
  message = '',
  description = '',
  type = 'info',
  button = false,
  buttons = null,
  duration = 5,
  style = {},
  onClose = () => { },
}: NotifProps) => {
  console.info('currentNotification', { currentNotification, message, description });
  if (currentNotificationModal) {
    console.info('Norification already present', currentNotificationModal);
  } else {
    const key = `open${Date.now()}`;

    currentNotificationModal = key;

    const btn =
      buttons || button ? (
        <Button
          type="primary"
          size="small"
          onClick={() => {
            onClose();
            notification.close(key);
          }}
        >
          {button}
        </Button>
      ) : null;

    notification[type]({
      duration,
      message: unescape(message),
      description,
      btn,
      style,
      key,
      onClose,
      className: type,
    });

    setTimeout(() => {
      currentNotificationModal = undefined;
    }, duration * 1000);
  }
};

export const showMessage = ({
  content = '',
  type = 'info',
  duration = 3,
  onClose = () => { },
}: {
  content: any;
  duration?: number;
  onClose?: any;
  type?: 'success' | 'info' | 'warning' | 'error' | 'loading';
}) => {
  message[type]({
    duration,
    content,
    onClose,
    className: type,
  });
};
